import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faTable } from '@fortawesome/free-solid-svg-icons';
import { Howl } from 'howler';
const clickOption = new Howl({ src: ['/sounds/click.mp3'] });

const AdminTable = () => {
  return (
    <div className="admin-layout">
      <Sidebar />
      <main>
        <div className="tf-card">
          <header style={{ marginBottom: '2.5rem' }}>
            <h1 className="tf-heading-md tf-flex" style={{ gap: '0.75rem', marginBottom: '0.5rem' }}>
              <FontAwesomeIcon icon={faTable} style={{ color: 'var(--tf-primary)' }} />
              Table Management
            </h1>
            <p style={{ color: 'var(--tf-text-muted)', fontSize: '0.95rem' }}>Organize and monitor restaurant seating by daily time slots</p>
          </header>

          <div className="tf-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
            {[1, 2, 3].map(slot => (
              <Link 
                to={`/admin/slot/${slot}`} 
                key={slot}
                className="tf-card"
                style={{ padding: '0', overflow: 'hidden', textDecoration: 'none', color: 'inherit', transition: 'var(--tf-transition)', border: '1px solid var(--tf-border)', background: 'rgba(255,255,255,0.02)' }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.borderColor = 'var(--tf-primary)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = 'var(--tf-border)'; }}
                onClick={() => clickOption.play()}
              >
                <div className="tf-flex-center" style={{ padding: '3rem 2rem', flexDirection: 'column', textAlign: 'center' }}>
                  <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: 'rgba(255,65,53,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem', color: 'var(--tf-primary)' }}>
                    <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: '1.5rem' }} />
                  </div>
                  <h3 className="tf-text-accent" style={{ margin: '0.5rem 0', fontSize: '1.4rem', fontWeight: '700' }}>Slot {slot}</h3>
                  <p style={{ color: 'var(--tf-text-muted)', fontSize: '0.85rem', lineHeight: '1.5' }}>Click to manage tables and reservations for this time period</p>
                </div>
                <div className="tf-flex-center" style={{ backgroundColor: 'var(--tf-primary)', color: 'white', padding: '1rem', fontWeight: '600', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
                  Open Dashboard
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminTable;